import * as React from "react"
import { Container, Box, Text, Section, Flex, Heading, Subhead } from "../../ui"
import { StaticImage } from "gatsby-plugin-image"
import { spancolor_5 } from "../../ui.css"
export default function Out_comeBl(props) {
    return (
        <Section style={{ background: "radial-gradient(88.77% 227.16% at 12.81% -73.17%, #2B237C 0%, #251C72 31%, #0F054C 100%)", color: "#FFF", transform: "skewY(-5deg)" }} >
            <Container style={{ transform: "skewY(5deg)" }} width="narrow2">
                <Flex gap={4} variant="responsive">
                    <Box>
                        <Subhead>
                            <span className={spancolor_5}>Outcome </span><StaticImage src="../images/skill_elevator_icon.png" transformOptions={{ fit: "cover", cropFocus: "attention" }} alt="skill_elevator_icon" width={20} style={{ marginTop: "2%" }} /><br />of Business Laboratory
                        </Subhead>
                        <Flex gap={4} variant="responsive" style={{ marginTop: "10%" }}>
                            <Box>
                                <Text>  <StaticImage src='../../../images/college_images/practical_experience.png' alt="practical_experience" width={40} /></Text>
                                <Text>Students get <span className={spancolor_5}>practical working experience</span> in the industry during their studies.</Text>
                            </Box>
                            <Box>
                                <Text>  <StaticImage src='../../../images/college_images/working_modules.png' alt="working_modules" width={40} /></Text>
                                <Text>The 20 modules in the bizzlab<br /> provide a <span className={spancolor_5}>rich work <br />experience and quicker job opportunity.</span></Text>
                            </Box>
                        </Flex>

                    </Box>
                    <Box>
                        <Text >
                            <StaticImage src='../../../images/college_images/college_img2.png' alt="college_img2" />
                        </Text>
                    </Box>
                </Flex>
              

                    <Flex gap={4} variant="responsive">
                        <Box>
                            <Text>   <StaticImage src='../../../images/college_images/verified_cv_certificate.png' alt="verified_cv_certificate" width={40} /></Text>
                            <Text>Platform automtically <br /> Prepare a CV and make it as <br /><span className={spancolor_5}>VerifiedCV </span>for high priority <br /> in job interviews.</Text>
                        </Box>
                        <Box>
                            <Text> <StaticImage src='../../../images/college_images/pro_accoutant.png' alt="pro_accountant" width={40} /></Text>
                            <Text>Students can get 1 year<br /> industry experience certificate <br />with <span className={spancolor_5}>Pro-Accountant certificate</span> <br />from the Company.</Text>
                        </Box>
                        <Box>
                            <Text><StaticImage src='../../../images/college_images/post_graduation.png' alt="post_graduation" width={40} /></Text>
                            <Text>Student can continuously do <br /><span className={spancolor_5}> practicals during their <br />graduation </span>or post graduation in the<br /> college.</Text>
                        </Box>
                    </Flex>
               
            </Container>
        </Section>                        
    )
}
